import { Box, Chip, Pagination, Stack, Typography, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { REPORTS_PER_PAGE } from '../../app/constants';
import { useUserIdFromRoute } from '../../app/hooks/useUserId';
import { ReportActions } from '../../redux/report/reportActions';
import {
  selectAllUserReports,
  selectAllUserReportsTotalCount,
} from '../../redux/report/reportSelectors';
import { selectUserId } from '../../redux/user/userSelectors';
import { ReportTile } from '../ReportTile/ReportTile';

export const ProfilePaginatedReportsContainer = () => {
  const theme = useTheme();
  const userId = useSelector(selectUserId);
  const dispatch = useDispatch();
  const userIdParam = useUserIdFromRoute(); //if some other user's profile

  const reports = useSelector(selectAllUserReports);
  const totalReports = useSelector(selectAllUserReportsTotalCount);
  const totalPages = Math.ceil(totalReports / REPORTS_PER_PAGE);
  const emptyText = 'No reports found.';

  const [showDrafts, setShowDrafts] = useState(true);
  const [showPublished, setShowPublished] = useState(true);
  const [page, setPage] = useState(1);

  useEffect(() => {
    dispatch(
      ReportActions.getAllUserReports({
        userId: userIdParam ? userIdParam : userId,
        getDrafts: userIdParam ? false : showDrafts,
        getPublished: userIdParam ? true : showPublished,
        page,
        limit: REPORTS_PER_PAGE,
      })
    );
  }, [dispatch, userId, showDrafts, showPublished, page]);

  useEffect(() => {
    setPage(1);
  }, [showDrafts, showPublished]);

  console.log(reports);

  return (
    <>
      {!userIdParam && (
        <Stack direction="row" spacing={2} mb={2} justifyContent="center">
          <Chip
            label="Drafts"
            clickable
            color={showDrafts ? 'primary' : 'default'}
            onClick={() => setShowDrafts((prev) => !prev)}
          />
          <Chip
            label="Published"
            clickable
            color={showPublished ? 'primary' : 'default'}
            onClick={() => setShowPublished((prev) => !prev)}
          />
        </Stack>
      )}
      {reports?.length != 0 ? (
        <Box
          sx={{
            width: '50%',
            display: 'flex',
            flexWrap: 'wrap',
            gap: 4,
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            padding: 4,
          }}
        >
          {reports?.map((report) => (
            <ReportTile
              key={report.id}
              id={report.id}
              title={report.title}
              hashtags={report.hashtags}
              content={report.content}
              coverImageUrl={report.coverImage || ''}
              author={report.authorName}
              datePublished={report.createdAt}
              status={report.status}
              isProfilePage
              userId={userId}
              userAvatar={report.authorAvatar}
            />
          ))}
        </Box>
      ) : (
        <Box sx={{ pt: 5, pb: 10 }}>
          <Typography
            sx={{ color: theme.palette.grey[500], letterSpacing: '0.05em', fontSize: 14 }}
          >
            {emptyText}
          </Typography>
        </Box>
      )}
      {totalPages > 1 && (
        <Stack alignItems="center" my={4}>
          <Pagination
            count={totalPages}
            page={page}
            onChange={(_, value) => setPage(value)}
            color="primary"
            shape="rounded"
          />
        </Stack>
      )}
    </>
  );
};
